import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location, NgFor } from '@angular/common';
import { PaymentService } from '../services/payment.service';
import { LinkService } from '../shared/services/link.service';
import { LinkInformation } from '../shared/interfaces/link-information';
import { PaymentStatus } from '../shared/enums/payment-status';
import { PaymentType } from '../shared/enums/payment-types';
import { Payment } from '../shared/interfaces/payment';
import { Router } from '@angular/router';
import { CountdownTimerComponent } from '../shared/components/countdown-timer/countdown-timer.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-payment-loading',
  standalone: true,
  imports: [CountdownTimerComponent, NgFor],
  templateUrl: './payment-loading.component.html',
  styleUrl: './payment-loading.component.css'
})
export class PaymentLoadingComponent implements OnInit, OnDestroy{

  linkInfo: LinkInformation = {}

  private onDestroy$ = new Subject<void>();

  steps: string[] =[
    "Deve ir para o seu telefone;",
    "Verá um push notification;",
    "Deve Colocar o seu PIN;",
    "Por fim deve aceitar."
  ]


  constructor(private router: Router, private location: Location ,private linkServ: LinkService,private paymentServ: PaymentService){}
  
  
  ngOnInit(): void {
    this.linkInfo = this.linkServ.getLinkInformation()
    
    if(this.linkInfo.amount == undefined){
      this.location.back();
    } else{
      this.makePayment();
    }
  }
  
  
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  makePayment(){
    

    this.paymentServ.createPayment(
      this.linkServ.getPaymentNumber(),
      this.linkInfo.amount!,
      this.linkInfo.store_account_number!,
      this.linkServ.getPaymentMethod(),
      PaymentType.PUSH
    )
    .pipe(takeUntil(this.onDestroy$))
    .subscribe(
      (data: Payment)=>{
        console.log(data);

        if(data.status !== PaymentStatus.PENDING){
          this.linkServ.clear()

          switch(data.status){
            case PaymentStatus.EXPIRED:
              this.router.navigate(['expired']);
            break;

            case PaymentStatus.FAILED:
              this.router.navigate(['pay/failed']);
            break;

            case PaymentStatus.SUCCESS:
              this.router.navigate(['used']);
            break;

            default:
              this.router.navigate(['pay/failed']);
            break;
          }
        }
      }
    )
  }

  onTimeout(){
    this.linkServ.clear();
    this.router.navigate(['pay/failed']);
  }
}
